import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		hasLogin: null,
		userInfo: null,
		headers: null,
		systemMsg:0,
		fonts:[],
		online:true,
		netWork: 2,
		school: null,
		bea:null,
		currentClass:null,
		beaStudents:[],
		beaSelect:null,
		forceToken: '',
		class_id: ''
	},
	mutations: {
		setForceToken(state, token) {
			state.forceToken = token
		},
		cleaBea(state) {
			state.bea = null 
			state.beaStudents = []
			state.beaSelect = null
		},
		login(state) {
			state.hasLogin = true;
		},
		setNetwork(state,netWork) {
			state.netWork = netWork;
		},
		setHasLogin(state, hasLogin) {
			state.hasLogin = hasLogin
		},
		setUserInfo(state,userInfo) {
			state.userInfo = userInfo
		},
		setHeader(state,headers) {
			state.headers = headers
			Cookies.set('token',headers)
		},
		setSystemMsg(state,num) {
			state.systemMsg = num
		},
		setFonts(state,fonts) {
			state.fonts = fonts
		},
		setOnline(state,online) {
			state.online = online
		},
		setSchool(state,school) {
			state.school = school
			state.userInfo.school = school
			localStorage.setItem('school', JSON.stringify(school))
		},
		setBea(state,bea) {
			state.bea = bea
		}
	},
	actions: {
		setBea({commit},bea) {
			commit('setBea', bea)
		},
		setUserInfo({commit}, userInfo) {
			commit('setUserInfo', userInfo)
		},
		setSchool({commit}, school) {
			commit('setSchool', school)
		},
		setNetwork({commit}, netWork) {
			commit('setNetwork', netWork)
		},
		setOnline({commit}, online) {
			commit('setOnline', online)
		},
		setHeader({commit}, headers) {
			commit('setHeader', headers)
			commit('login')
		},
		logOut({commit},) {
			commit('setHeader', {})
			commit('setUserInfo', null)
			commit('hasLogin', false)
			Cookies.remove('loginform')
			Cookies.remove('token')
		},
		setSystemMsg({commit},num) {
			commit('setSystemMsg', num)
		},
		setFonts({commit},fonts) {
			commit('setFonts', fonts)
		}
	}
})

export default store
